import IGenericResult from "../interfaces/IGenericResult";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
class ClienteService {
    async update(data: any) {
        return await api.put<any>(`${resources.cliente}/Update`, data);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.cliente}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getClientes() {
        return await api.get<IGenericResult[]>(`${resources.cliente}/GetAllClientes`);
    }
}

export default new ClienteService();
